import { render, staticRenderFns } from "./SettingsListView.vue?vue&type=template&id=00074c6b&scoped=true&"
import script from "./SettingsListView.vue?vue&type=script&lang=ts&"
export * from "./SettingsListView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00074c6b",
  null
  
)

export default component.exports